export default __webpack_public_path__ + "static/899-9fb274d0a5712c958f673fb20f11f8b1.gif";